[
  {
    "name": "Bank & Cash",
    "icon": "💰",
    "key": "AssetsBank",
    "finGroup": "Assets"
  },
  {
    "name": "Education",
    "icon": "🎓",
    "key": "AssetsEducation",
    "finGroup": "Assets"
  },
  {
    "name": "Equity",
    "icon": "🪙",
    "key": "AssetsEquity",
    "finGroup": "Assets"
  },
  {
    "name": "Insurance",
    "icon": "🩺",
    "key": "AssetsInsurance",
    "finGroup": "Assets"
  },
  {
    "name": "Investment",
    "icon": "📊",
    "key": "AssetsInvestment",
    "finGroup": "Assets"
  },
  {
    "name": "Miscellaneous",
    "icon": "💎",
    "key": "AssetsMiscellaneous",
    "finGroup": "Assets"
  },
  {
    "name": "Retirement",
    "icon": "🌅",
    "key": "AssetsRetirement",
    "finGroup": "Assets"
  },
  {
    "name": "Education",
    "icon": "🎓",
    "key": "ContributionsEducation",
    "finGroup": "Contributions"
  },
  {
    "name": "General",
    "icon": "💰",
    "key": "ContributionsGeneral",
    "finGroup": "Contributions"
  },
  {
    "name": "Retirement",
    "icon": "🌅",
    "key": "ContributionsRetirement",
    "finGroup": "Contributions"
  },
  {
    "name": "Benefits",
    "icon": "🛡️",
    "key": "CoverageBenefits",
    "finGroup": "Coverage"
  },
  {
    "name": "Self-Employment",
    "icon": "🚀",
    "key": "ExpensesEntrepreneurship",
    "finGroup": "Expenses"
  },
  {
    "name": "General",
    "icon": "💰",
    "key": "ExpensesGeneral",
    "finGroup": "Expenses"
  },
  {
    "name": "Insurance",
    "icon": "🩺",
    "key": "ExpensesInsurance",
    "finGroup": "Expenses"
  },
  {
    "name": "Miscellaneous",
    "icon": "💎",
    "key": "ExpensesMiscellaneous",
    "finGroup": "Expenses"
  },
  {
    "name": "Obligation",
    "icon": "🔔",
    "key": "ExpensesObligation",
    "finGroup": "Expenses"
  },
  {
    "name": "Big Plans",
    "icon": "📌",
    "key": "ExpensesPlanned",
    "finGroup": "Expenses"
  },
  {
    "name": "Property",
    "icon": "🏡",
    "key": "ExpensesProperty",
    "finGroup": "Expenses"
  },
  {
    "name": "Employment",
    "icon": "💼",
    "key": "IncomeEmployment",
    "finGroup": "Income"
  },
  {
    "name": "Entrepreneurship",
    "icon": "🚀",
    "key": "IncomeEntrepreneurship",
    "finGroup": "Income"
  },
  {
    "name": "Investment",
    "icon": "📊",
    "key": "IncomeInvestment",
    "finGroup": "Income"
  },
  {
    "name": "Miscellaneous",
    "icon": "💎",
    "key": "IncomeMiscellaneous",
    "finGroup": "Income"
  },
  {
    "name": "Property",
    "icon": "🏡",
    "key": "IncomeProperty",
    "finGroup": "Income"
  },
  {
    "name": "Retirement",
    "icon": "🌅",
    "key": "IncomeRetirement",
    "finGroup": "Income"
  },
  {
    "name": "Special & Tax-Advantaged",
    "icon": "💡",
    "key": "IncomeSpecial",
    "finGroup": "Income"
  },
  {
    "name": "Credits & Lease",
    "icon": "💳",
    "key": "LiabilitiesCredit",
    "finGroup": "Liabilities"
  },
  {
    "name": "Line of Credit",
    "icon": "💳",
    "key": "LiabilitiesLoc",
    "finGroup": "Liabilities"
  },
  {
    "name": "Property",
    "icon": "🏡",
    "key": "RealEstate",
    "finGroup": "Assets"
  },
  {
    "name": "Deductions, Exemptions & Credits",
    "icon": "🏛️",
    "key": "TaxesBenefit",
    "finGroup": "Taxes"
  },
  {
    "name": "Self-Employment Taxes",
    "icon": "🚀",
    "key": "TaxesEntrepreneurship",
    "finGroup": "Taxes"
  },
  {
    "name": "FICA Taxes",
    "icon": "💼",
    "key": "TaxesFica",
    "finGroup": "Taxes"
  },
  {
    "name": "Federal & State Income Taxes",
    "icon": "💰",
    "key": "TaxesIncome",
    "finGroup": "Taxes"
  },
  {
    "name": "Federal Surtaxes & Other",
    "icon": "📈",
    "key": "TaxesOther",
    "finGroup": "Taxes"
  },
  {
    "name": "Property Tax",
    "icon": "🏡",
    "key": "TaxesProperty",
    "finGroup": "Expenses"
  },
  {
    "name": "Quest",
    "icon": "❓",
    "key": "TechnicalQuest",
    "finGroup": "Technical"
  },
  {
    "name": "Transactions",
    "icon": "⚙️",
    "key": "TechnicalTransaction",
    "finGroup": "Technical"
  },
  {
    "name": "Transfer",
    "icon": "↩️",
    "key": "Transfer",
    "finGroup": "Technical"
  }
]
